var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"links"},_vm._l((_vm.links),function(link,index){return _c('li',{key:index,staticClass:"links__item"},[_c('button-link-of-admin-tool-bar',_vm._b({staticClass:"button"},'button-link-of-admin-tool-bar',link,false))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }